import {
  FETCH_CANDIDATE_REQUEST,
  FETCH_CANDIDATE_SUCCESS,
  FETCH_CANDIDATE_FAILURE
} from './candidateAct'

const init = {
  details: {},
  loading: false,
  error: null
}

const candidateReducer = (state = init, action) => {
  switch (action.type) {
    case FETCH_CANDIDATE_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_CANDIDATE_SUCCESS:
      return { ...state, loading: false, details: action.payload }
    case FETCH_CANDIDATE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default candidateReducer
